import { dispatcher } from "../../../../helpers/projectHelper";
import { UnityEvent, waitForEventOnce } from "../../../../helpers/unityPubSub";
import { getAppState } from "../../../../redux/store";
import {
  selectIsLoading,
  setCuratorLoader
} from '../../../../redux/slicers/admin/curatorSlicer';
import PubSub from 'pubsub-js';
import {
  resetState, setUndoRedoOperation
} from '../../../../redux/slicers/admin/curatorTileGroutSlicer';

export class UndoRedoTileGrout {
  constructor({ undoRedoInstance, unityContext }) {
    this.unityContext = unityContext;
    this.undoRedo = undoRedoInstance;

    // const callback = (receivedVallue) => {
    //   if (receivedVallue === 'FloorTextureGenerationCompleted') {
    //     dispatcher(setCuratorLoader(true));
    //   }
    // };

    this.init();
    // PubSub.subscribe(UnityEvent.FloorTextureGenerationCompleted, callback);
  }

  init = () => {
    this.addPattern = this.undoRedo.createAction(({ prevValue, nextValue, modifiedValue }) => {
      return {
        __ACTION__: 'ADD_PATTERN',
        type: 'ADD_PATTERN',
        data: {
          nextValue,
          prevValue,
        },
        undo: async () => {
          const curatorLoader = selectIsLoading(getAppState());
          if (!curatorLoader) {
            if (prevValue?.RendererType) {
              dispatcher(setCuratorLoader(false));
              dispatcher(setUndoRedoOperation({
                isOperation: true,
                data: prevValue,
                modifiedValue,
                operation: 'undo'
              }))
              await this.unityContext.floorPanelController.selectPattern({
                patternData: prevValue
              });
            } else {
              dispatcher(setUndoRedoOperation({
                isOperation: true,
                data: 'reset',
                modifiedValue,
                operation: 'undo'
              }))
              dispatcher(resetState())
              this.unityContext.floorPanelController.OnResetUnityWindow()
            }
          }
        },
        redo: async () => {
          const curatorLoader = selectIsLoading(getAppState());
          if (!curatorLoader) {
            dispatcher(setUndoRedoOperation({
              isOperation: true,
              data: nextValue,
              modifiedValue,
              operation: 'redo'
            }))
          }
        },
      };
    }, { pause: true });

    this.addProperties = this.undoRedo.createAction(({ prevValue, nextValue, modifiedValue }) => {
      return {
        __ACTION__: 'ADD_TILE_PROPERTIES',
        type: 'ADD_TILE_PROPERTIES',
        data: {
          nextValue,
          prevValue,
        },
        undo: async () => {
          const curatorLoader = selectIsLoading(getAppState());
          if (!curatorLoader) {
            if (prevValue?.RendererType) {
              dispatcher(setUndoRedoOperation({
                isOperation: true,
                data: prevValue,
                modifiedValue,
                operation: 'undo'
              }))
            }
          }
        },
        redo: async () => {
          const curatorLoader = selectIsLoading(getAppState());
          if (!curatorLoader) {
            dispatcher(setUndoRedoOperation({
              isOperation: true,
              data: nextValue,
              modifiedValue,
              operation: 'redo'
            }))
          }
        },
      };
    }, { pause: true });

    this.addDepthValue = this.undoRedo.createAction(({ prevValue, nextValue, modifiedValue }) => {
      return {
        __ACTION__: 'ADD_DEPTH_VALUE',
        type: 'ADD_DEPTH_VALUE',
        data: {
          nextValue,
          prevValue,
        },
        undo: async () => {
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: prevValue,
            modifiedValue,
            operation: 'undo'
          }))
          await this.unityContext.floorPanelController.changeDepthValue(parseFloat(prevValue));
        },
        redo: async () => {
          await this.unityContext.floorPanelController.changeDepthValue(parseFloat(nextValue));
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: nextValue,
            modifiedValue,
            operation: 'redo'
          }))
        }
      };
    }, { pause: true })

    this.addLock = this.undoRedo.createAction(({ prevValue, nextValue, modifiedValue }) => {
      return {
        __ACTION__: 'ADD_LOCK',
        type: 'ADD_LOCK',
        data: {
          nextValue,
          prevValue,
        },
        undo: async () => {
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: prevValue,
            modifiedValue,
            operation: 'undo'
          }))
        },
        redo: async () => {
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: nextValue,
            modifiedValue,
            operation: 'redo'
          }))
        }
      };
    }, { pause: true })

    this.addErosion = this.undoRedo.createAction(({ prevValue, nextValue, modifiedValue }) => {
      return {
        __ACTION__: 'ADD_EROSION',
        type: 'ADD_EROSION',
        data: {
          nextValue,
          prevValue,
        },
        undo: async () => {
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: prevValue,
            modifiedValue,
            operation: 'undo'
          }))
        },
        redo: async () => {
          dispatcher(setUndoRedoOperation({
            isOperation: true,
            data: nextValue,
            modifiedValue,
            operation: 'redo'
          }))
        }
      };
    }, { pause: true })

  }
}